export default function isEmptyUtil (value) {
  if (value == null) {
    return true
  }

  if (
    value instanceof Map ||
    value instanceof Set
  ) {
    return value.size === 0
  }

  if (
    typeof value === 'string' ||
    Array.isArray(value)
  ) {
    return value.length === 0
  }

  if (
    typeof value === 'object' &&
    Object.keys(value).length === 0
  ) {
    return true
  }

  return false
}
